import React from 'react';
import PropTypes from 'prop-types';

import Container from '@Theme/hellofinance/components/Container/Container';
import Row from '@Theme/hellofinance/components/Row/Row';
import Column from '@Theme/hellofinance/components/Column/Column';
import GenericAuthorItem from './GenericTeamItem';

import * as styles from './GenericTeam.module.scss';

const propTypes = {
  /**
   * Heading content
   */
  heading: PropTypes.string,

  /**
   * Array of authors, single author contains image, name, role and title
   */
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string
      }),
      fullName: PropTypes.string,
      role: PropTypes.string,
      href: PropTypes.string
    })
  ),

  /**
   * Boolean value - if set to true - will hide component on mobile screen
   */
  isHiddenMobile: PropTypes.bool,
  center: PropTypes.bool
};

const GenericTeam = ({
  heading,
  authors,
  isHiddenMobile,
  center
}) => {
  if (!heading && !authors) {
    return false;
  }

  return <section className={`${styles.root} ${isHiddenMobile ? styles.rootMobileHidden : ''}`}>
    <Container classname={styles.rootContainer}>
      {heading &&
        <h2 className={styles.rootHeading} dangerouslySetInnerHTML={{ __html: heading }} />}
      {authors && <Row classname={styles.rootRow}>
        <Column
          xs={4}
          md={{
            offset: 2,
            col: 8
          }}>
          <div className={`${styles.rootAuthorsWrapper} ${center ? styles.rootAuthorsWrapperCenter : ''}`}>
            {authors.map((author, index) => (<React.Fragment key={index}>
              <GenericAuthorItem {...author} />
            </React.Fragment>
            ))}
          </div>
        </Column>
      </Row>}
    </Container>
  </section>;
};

GenericTeam.propTypes = propTypes;

export default GenericTeam;
